import {
  SAVE_INVOICES_LIST,
  SAVE_INVOICE_DETAILS
} from 'redux/constants/Invoices';

const theme = (state = {}, action) => {
  switch (action.type) {
  case SAVE_INVOICES_LIST:
    return {
      ...state,
      list: action.payload
    };
  case SAVE_INVOICE_DETAILS:
    return {
      ...state,
      details: action.payload
    };
  default:
    return state;
  }
};

export default theme